import type { IconName } from '@core/user-interface-legacy';

import type { IntegrationImage } from '../../common/components/svg-asset/svg-asset.component';
import type { DynamicText } from '../../dynamic/types';
import type { ResultStatus, ResultStatusCategory, RoleAbilityMap } from '../../misc/types';

export type { Candidate } from '../../misc/types';

export enum PARTNER_ABILITIES {
  VIEW = 'view',
  SEND = 'send',
}

export enum REPORT_STATUS {
  SENT = 'sent',
  COMPLETED = 'completed',
  FAILED = 'failed',
  CANCELED = 'canceled',
}

export enum INTEGRATION_STATUS {
  ACTIVE = 'active',
  PENDING = 'pending',
  INACTIVE = 'inactive',
}

export enum LINK_TYPE {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export enum HTTP_METHODS {
  GET = 'get',
  DELETE = 'delete',
}

type Admin = {
  id: number;
  firstName: string;
  lastName: string;
  avatarUrl: string | null;
  hasAvatar: boolean;
  initials: string;
};

export type ReportProperty = {
  key: string;
  value: string;
};

export type OpenLinkResult =
  | { kind: 'Noop' }
  | { kind: 'Report'; report: Report }
  | { kind: 'Url'; url: string };

export type Link = {
  label: DynamicText;
  url: string;
  type: LINK_TYPE;
  confirmDialog: {
    title: string;
    message: string;
    cancelLabel: string;
    agreeLabel: string;
  };
  notificationKey: string;
  buttonIconName: IconName;
  httpMethod: HTTP_METHODS;
};

export type Report = {
  id: string;
  testName: string;
  status: REPORT_STATUS;
  score: string | null;
  subtitle: string | null;
  properties: ReportProperty[] | null;
  buttonLinks: Link[];
  dropdownLinks: Link[];
  badge?: PartnerBadge;
  statusBadge?: ResultStatus;
  sentByAdmin: {};
  sentAt: string;
  canceledByAdmin: {};
  canceledAt: string;
  candidateId: string;
};

export type AdminCredential = {
  id: string;
  createdAt: string;
  admin: Admin;
};

export type PartnerBadge = {
  logo?: IntegrationImage;
  logoSvg?: string | null;
  logoFill?: string;
  resultStatusCategory?: ResultStatusCategory | null;
  resultText?: string | null;
  tooltip: string;
  disabled?: boolean;
  scrollTo?: string;
};

export type PartnerIntegrationBase = {
  id: number;
  status: INTEGRATION_STATUS;
  roles: RoleAbilityMap;
  adminId: number;
  companyId: number;
  partnerId: string;
  adminCredentials: AdminCredential[];
};

export type EmbedToken = {
  token: string;
};

export type KomboCredentials = {
  tokenPartial?: null;
  komboConnectionLink: string;
};

export type TokenCredentials = {
  tokenPartial: string;
  komboConnectionLink?: null;
};

export type PartnerIntegration =
  | (PartnerIntegrationBase & TokenCredentials)
  | (PartnerIntegrationBase & KomboCredentials);
